import { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { COMPLAINT_REPORT_ROUTE, COMPLAINT_REPORT_GET_MECHANIC_DATA_ROUTE, COMPLAINT_REPORT_GET_CITY_DATA_ROUTE } from "./CustomerReportConstant";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { ALLOWED_MODULES } from "../../constants/enums";

const ComplaintReportTab = Loadable(
    lazy(() =>
        import("./ComplaintReport-tab").then(({ ComplaintReportTab }) => ({
            default: ComplaintReportTab,
        }))
    )
);

const ComplaintReportDetails = Loadable(
    lazy(() =>
        import("./ComplaintReportDetails/ComplaintReportDetails").then(({ ComplaintReportDetails }) => ({
            default: ComplaintReportDetails,
        }))
    )
);

export const ComplaintReportRoutes = [
    {
        path: COMPLAINT_REPORT_ROUTE,
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess={true}
                moduleIds={[ALLOWED_MODULES.COMPLAINT_REPORT]}
            >
                <ComplaintReportTab />
            </AuthorizedRoute>
        ),
    },
    {
        path: COMPLAINT_REPORT_GET_MECHANIC_DATA_ROUTE,
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess={true}
                moduleIds={[ALLOWED_MODULES.COMPLAINT_REPORT]}
            >
                <ComplaintReportDetails />
            </AuthorizedRoute>
        ),
    },
    {
        path: COMPLAINT_REPORT_GET_CITY_DATA_ROUTE,
        exact: true,
        element: (
            <AuthorizedRoute
                allowFullAccess={true}
                moduleIds={[ALLOWED_MODULES.COMPLAINT_REPORT]}
            >
                <ComplaintReportDetails />
            </AuthorizedRoute>
        ),
    },
];